// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"51a29c0c","403":"471fdeb3","453":"be1488fc","629":"f37b67db"}[chunkId] + ".chunk.js";
};